export interface JitsiUserInfo {
  displayName?: string;
  email?: string;
}

export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const padLen = (4 - (payload.length % 4)) % 4;
    const padded = payload + "=".repeat(padLen);
    const json = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function extractJitsiUserFromToken(
  token: string | null | undefined,
): JitsiUserInfo | undefined {
  if (!token) return undefined;
  const payload = decodeJwtPayload(token);
  if (!payload) return undefined;
  const ctx = payload.context as { user?: { name?: string; email?: string } } | undefined;
  const u = ctx?.user;
  if (!u) return undefined;
  return { displayName: u.name, email: u.email };
}

